import { useQuery } from "@tanstack/react-query";
import { GET_GOALS } from "api/dataProviderTypes";
import fetchApi from "api/fetchApi";
import { ApiResponseItem } from "api/types";
import { IReturnType } from "hooks/types";
import { useSnackbar } from "hooks/useSnackbar";
import IGoal from "models/Goal";

export const useGetGoals = () => {
  const { showSnackbar } = useSnackbar();

  const {
    data: response,
    isLoading,
    isError,
    isFetching,
    isSuccess,
    refetch,
  }:IReturnType<ApiResponseItem<IGoal[]>> = useQuery([GET_GOALS], () => fetchApi(`kpis`).get(""), {
    onSuccess: (data) => {
      showSnackbar("Goals Fetched Successfully", "success");
    },
    onError: (error) => {
      showSnackbar("Failed to Retrieve Goals", "error");
    },
  });

  const goals = response?.data?.items || [];

  return { goals, isLoading, isError, isFetching, isSuccess, refetch };
};
